import React, { Component } from 'react'
import KindredLogo from '../../assets/kp png logo.svg';

import './styles/LoginScreen.css'

export default class LoginScreen extends Component {

	state = {
		email: '',
		password: ''
	}

	handleEmailChange = (event) => {
		this.setState({
			email: event.target.value
		})
	}

	handlePasswordChange = (event) => {
		this.setState({
			password: event.target.value
		})
	}

  render() {
    return (
      <div className = "admin-container">
        <div className = "login-wrapper">
          <div className = "login-box">
						<div className="login-logo-container"><img src={KindredLogo} /></div>
						<div className="error-msg-container">{this.props.errorMsg}</div>
						<div className="credentials-txt-box">
							<input className="txt-input whole" type="email" placeholder="ID/Email"
											value={this.state.email}
											onChange={this.handleEmailChange} />
						</div>
						<div className="credentials-txt-box">
							<input className="txt-input whole" type="password" placeholder="Password"
											value={this.state.password}
											onChange={this.handlePasswordChange} />
						</div>
						<div className="login-btn-container">
							<button className="btn btn-submit btn-span"
											onClick={this.props.loginAction.bind(this, this.state.email, this.state.password)}>Login</button>
						</div>
					</div>
        </div>
      </div>
    )
  }
}
